<script lang="ts">
    import {HomeSolid} from "flowbite-svelte-icons";

    export let address;

    export let showMap = false;

    export let withIcon = false;

</script>
<div class="w-full">

    <div class="flex gap-2 items-center mb-6">
        {#if withIcon}
            <HomeSolid slot="left" class="w-4 h-4 text-primary-400" />
        {/if}
        <div>
            <h3 class="text-neutral-600">{address?.name} <i class="las la-map-marked cursor-pointer text-lg" on:click={() => showMap =! showMap}></i></h3>
            <div class="text-sm text-neutral-500">
                {address.street} {address.number} <br>
                {address.zip} {address.place}
            </div>
        </div>

    </div>

    {#if showMap}
        <iframe title="Map" class="col-span-2" width="100%" height="100%" id="gmap_canvas"
                src={`https://maps.google.com/maps?q=${address.street.replace(/\s/, '%20')}%20${address.number}%20${address.place}%20${address.country}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
        </iframe>
    {:else if !withIcon}
        <div class="text-sm text-neutral-500">
            {address.street} {address.number} <br>
            {address.zip} {address.place}
        </div>
    {/if}



</div>